import { useState } from 'react';

import MetricCard from '@/app/(app)/analytics/call-analytics/[id]/components/call-metrics-card';
import { ApiSchemas } from '@/components/providers/v1-api';
import { Button } from '@/components/ui/button';

type Metrics = ApiSchemas['ExternalCallMetricDetailsOut'];

export function CallMetrics({ callId, metrics }: { callId: string; metrics: Metrics }) {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <div className='space-y-2'>
      <div className='flex items-center justify-between px-2'>
        <h2 className='text-heading-sm text-muted-foreground'>Metrics</h2>
        <Button
          onClick={() => setIsEditing(!isEditing)}
          variant='outline'
          size='sm'
          className='min-w-24 text-muted-foreground'
        >
          {isEditing ? 'Done' : 'Edit Metrics'}
        </Button>
      </div>
      <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
        {Object.keys(metrics.metrics ?? {})
          .sort()
          .map((key) => {
            const result = (metrics.metrics ?? {})[key];
            return <MetricCard key={key} callId={callId} metric={result} metricKey={key} isEditing={isEditing} />;
          })}
      </div>
    </div>
  );
}
